import React from 'react';
// mui
import { Drawer, Box } from '@mui/material';
import { styled, makeStyles } from '@mui/styles';
import { CurrencyAmount } from '@cowbell/ui/core';

// components
import { P100CoveragesReadOnly } from '../../../_tabs/quotesPolicyCommon/P100CoveragesReadOnly';

function P100QuoteDetailsDrawer({ open, onClose, quote }: any) {
  const classes = useStyles();

  return (
    <Drawer
      // @ts-expect-error TS(2322): Type '{ children: Element[]; pt: number; anchor: "... Remove this comment to see the full error message
      pt={2}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={classes}
    >
      <h2 className={classes.header}>Renewal Quote Details</h2>

      <FlexBox>
        <Text>Binder Number</Text>
        <Text>{quote.quoteNumber || '-'}</Text>
      </FlexBox>

      <FlexBox>
        <Text>Quote Created</Text>
        <Text>{quote.formattedCreated || '-'}</Text>
      </FlexBox>

      <FlexBox>
        <Text>Quote Expires</Text>
        <Text>{quote.formattedExpiresOn || '-'}</Text>
      </FlexBox>

      <FlexBox>
        <Text>Policy Effective</Text>
        <Text>{quote.formattedEffectiveDate || '-'}</Text>
      </FlexBox>

      <FlexBox>
        <Text>Policy Expiration</Text>
        <Text>{quote.formattedEndDate || '-'}</Text>
      </FlexBox>

      <FlexBox>
        <Text>Policy Term</Text>
        <Text>{quote.formattedPolicyTerm || '-'}</Text>
      </FlexBox>

      <FlexBox>
        <Text>Agent</Text>
        <Text>{`${quote.agentFirstName || ''} ${quote.agentLastName || ''} (${
          quote.agentEmail || ''
        })`}</Text>
      </FlexBox>

      {/* @ts-expect-error: FIXME */}
      <FlexBox borderBottom justifyContent="flex-start" mt={1}>
        {/* @ts-expect-error: FIXME */}
        <Text fontSize="tertia" textTransform="uppercase" padding="0.35rem 0">
          Coverages
        </Text>
      </FlexBox>

      {/* @ts-expect-error: FIXME */}
      <FlexBox borderBottom padding="0 0 0.75rem 0.25rem">
        <P100CoveragesReadOnly data={quote} state={quote.state} />
      </FlexBox>

      <Box display="flex" mt={2} width="100%">
        <Box
          display="flex"
          width="50%"
          flexDirection="column"
          justifyContent="flex-start"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            {/* @ts-expect-error: FIXME */}
            <Text fontSize="tertia">Aggregate Limit</Text>
            {/* @ts-expect-error: FIXME */}
            <Text fontSize="tertia">
              <CurrencyAmount
                amount={quote.limit}
                currency={quote.currency}
                minimumFractionDigits={0}
              />
            </Text>
          </Box>

          <Box
            display="flex"
            mt={1}
            justifyContent="space-between"
            alignItems="flex-start"
          >
            {/* @ts-expect-error: FIXME */}
            <Text fontSize="tertia">Deductible</Text>
            {/* @ts-expect-error: FIXME */}
            <Text fontSize="tertia">
              <CurrencyAmount
                amount={quote.deductible}
                currency={quote.currency}
                minimumFractionDigits={0}
              />
            </Text>
          </Box>
        </Box>

        <Box width="6%" />

        <Box display="flex" width="50%" flexDirection="column">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            {/* @ts-expect-error: FIXME */}
            <Text fontSize="tertia">Waiting Period</Text>
            {/* @ts-expect-error: FIXME */}
            <Text fontSize="tertia">
              {quote.waitingPeriod ? `${quote.waitingPeriod} hours` : '-'}
            </Text>
          </Box>

          <Box
            display="flex"
            mt={1}
            justifyContent="space-between"
            alignItems="flex-start"
          >
            {/* @ts-expect-error: FIXME */}
            <Text width="7rem" fontSize="tertia">
              Retro Active Period
            </Text>
            {/* @ts-expect-error: FIXME */}
            <Text fontSize="tertia">{quote.retroactivePeriod || '-'}</Text>
          </Box>
        </Box>
      </Box>

      <FlexBox mt={2}>
        {/* @ts-expect-error: FIXME */}
        <Text color="title" isBold fontSize="paragon">
          Total Amount
        </Text>

        {/* @ts-expect-error: FIXME */}
        <Text color="title" isBold fontSize="paragon">
          <CurrencyAmount amount={quote.totalPremium} currency={quote.currency} />
        </Text>
      </FlexBox>
    </Drawer>
  );
}

const useStyles = makeStyles(({ palette, config }) => ({
  paper: {
    width: '36rem',
    height: '62.34rem',
    padding: '0.9rem 1.25rem 0 1.25rem',
    color: palette.primary.main,
    backgroundColor: palette.background.modal,
    border: `1px solid ${palette.primary.border2}`,
    display: 'flex',
    alignItems: 'center',
    margin: 'auto 0',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 15,
    borderRadius: '0.9rem',
  },
  header: {
    fontSize: config.textSizes.tertia,
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '1.15rem',
    borderBottom: `1px solid ${palette.primary.modalBorder}`,
  },
}));

const Text = styled('p')(
  ({
    // @ts-expect-error TS(2339): Property 'width' does not exist on type '{ theme: ... Remove this comment to see the full error message
    width,
    color,
    // @ts-expect-error TS(2339): Property 'isBold' does not exist on type '{ theme:... Remove this comment to see the full error message
    isBold,
    // @ts-expect-error TS(2339): Property 'textTransform' does not exist on type '{... Remove this comment to see the full error message
    textTransform,
    // @ts-expect-error TS(2339): Property 'fontSize' does not exist on type '{ them... Remove this comment to see the full error message
    fontSize,
    // @ts-expect-error TS(2339): Property 'margin' does not exist on type '{ theme:... Remove this comment to see the full error message
    margin,
    // @ts-expect-error TS(2339): Property 'padding' does not exist on type '{ theme... Remove this comment to see the full error message
    padding,
    theme,
  }) => ({
    fontSize: fontSize
      ?
        `${theme.config.textSizes[fontSize]}`
      : theme.config.textSizes.normal,
    margin: margin || 0,
    textTransform: textTransform || 'normal',
    padding: padding || 0,
    color: color ? theme.palette.primary[color] : theme.palette.primary.main,
    width: width || 'none',
    fontWeight: isBold
      ? theme.config.weights.bold
      : theme.config.weights.normal,
  })
);

// @ts-expect-error TS(2345): Argument of type '({ borderBottom, justifyContent,... Remove this comment to see the full error message
const FlexBox = styled(Box)(({ borderBottom, justifyContent, theme }) => ({
  display: 'flex',
  justifyContent: justifyContent || 'space-between',
  alignItems: 'center',
  width: '100%',
  marginBottom: '0.35rem',
  borderBottom: borderBottom
    ? `1px solid ${theme.palette.primary.modalBorder}`
    : 'none',
}));

export const P100QuoteDrawer = ({ quote, toggle = false, setToggle }: any) => {
  const closeHandler = () => setToggle(false);
  return (
    <P100QuoteDetailsDrawer
      quote={quote}
      open={toggle}
      onClose={closeHandler}
    />
  );
};
